module.exports = __webpack_public_path__ + "media/images/logo-with-text-inverted-9600ce2e.svg";